import {useMaintenanceStore} from "@/shared/stores/maintenance.store.ts";
//@ts-ignore
import SYSTEM_SUBSCRIPTIONS from "@@/graphql/subscription/system.subscription.graphql";
import {Subscription} from "zen-observable-ts";
import {getApolloClient} from "@/shared/apolloclient/apollo.client.ts";

let systemSubscription: Subscription = null

/**
 * Sets up system GraphQL subscription with retry logic.
 */
export function setupSystemSubscription() {
    const apolloClient = getApolloClient();
    systemSubscription = apolloClient.subscribe({
        query: SYSTEM_SUBSCRIPTIONS, // Assuming this is imported elsewhere
    }).subscribe({
        next: (result) => {
            const event = result.data.system;
            if (event["__typename"] === "SystemShutdown") {
                const maintenanceStore = useMaintenanceStore();
                maintenanceStore.expectedMaintenanceWindow = event.expectedMaintenanceWindow;
                maintenanceStore.maintenance = true;
                console.log(`The backend system is shutting down, going into maintenance mode`, event);
            } else if (event["__typename"] === "SystemWelcome") {
                const maintenanceStore = useMaintenanceStore();
                maintenanceStore.maintenance = false;
                console.log(`Connected/reconnected to system messages`, event);
            } else {
                console.log(`Unknown event type`, event);
            }
        },
        error: (err) => {
            console.error('System subscription error:', err);
            // Optionally, handle persistent errors (e.g., notify user)
        },
        complete: () => {
            console.log('System subscription completed');
        },
    });
    return systemSubscription
}

export function unsubscribeSystemSubscription() {
    try {
        systemSubscription.unsubscribe()
    } catch (e) {
        console.error(e)
    }
}